import React, { useEffect, useState } from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import AllTab from "./tabbed/AllTab";
import CompletedTab from "./tabbed/CompletedTab";
import NewTab from "./tabbed/NewTab";
import { toast } from "react-toastify";
import { GET_MANAGE_BOOKINGS } from "../../../services/ApiCalls";
import moment from "moment";
import ul from "../../../Assets/images/user.png";
import Table from "../../../components/Common/Table";
import CustomPagination from "../../../components/Common/CustomPagination";
import TableProfile from "../../../components/Common/TableProfile";
import { Link } from "react-router-dom";

const ManageBooking = () => {
  const [tab, setTab] = useState("all");
  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
  });
  const [booking, setBooking] = useState([]);
  const [loader, setLoader] = useState(false);
  const [total, setTotal] = useState(0);

  const getBookingData = async (body) => {
    setLoader(true);
    try {
      const res = await GET_MANAGE_BOOKINGS(body);

      if (res?.data?.status === "success") {
        setBooking(res.data.data);
        setLoader(false);

        setTotal(res?.data?.totalcount);
      } else {
        toast.error(res.data.message);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);

      toast.success("something went wrong");
    }
  };

  useEffect(() => {
    const newBody = {
      ...body,
      page: 1,
      status: tab,
    };

    setBody(newBody);

    getBookingData(newBody);
  }, [tab]);

  const paginationHandler = (page) => {
    const newBody = {
      ...body,
      page,
      status: tab,
    };

    setBody(newBody);
    getBookingData(newBody);
  };

  const col = [
    {
      label: "Sr no",
      id: "srNo",
      isComponent: true,
      component: (_, key) => (
        <p className={` m-0`}>{(body.page - 1) * body.limit + (key + 1)}</p>
      ),
    },
    {
      label: "Booking Id",
      id: "bookingNumber",
    },
    {
      label: "Customer Name",
      id: "name",
      isComponent: true,
      component: (item, arr) => (
        <TableProfile
          imageSrc={item.customerDetails.profileImage}
          name={item.customerDetails.name}
        />
      ),
    },
    {
      label: "Vehicle Type",
      id: "serviceType",
      isComponent: true,
      component: (item, arr) => <p className={` m-0`}>{item.serviceType}</p>,
    },
    {
      label: "Price",
      id: "subTotal",
      isComponent: true,
      component: (item, arr) => <p className={` m-0`}>${item.subTotal}</p>,
    },
    {
      label: "Status",
      id: "status",
      isComponent: true,
      component: (item, key, data) => {
        return (
          <p
            className={`${
              item.status === "pending"
                ? "text-warning"
                : item.status === "confirmed"
                ? "text-primary"
                : "text-success"
            } m-0 fw-sbold `}
          >
            {item?.status.charAt(0).toUpperCase() + item?.status.slice(1)}
          </p>
        );
      },
    },
    {
      label: "Created at",
      id: "createdAt",
      isComponent: true,
      component: (item) => (
        <p className={` m-0`}>
          {moment(item.createdAt).format("MM-DD-YYYY , HH:mm A")}
        </p>
      ),
    },
    {
      label: "View",
      id: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn">
          <Link
            to={`/manage-booking/detail/${item._id}`}
            className="border-0 p-0"
            variant="transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 25 17"
              fill="none"
            >
              <path
                d="M24.8389 7.9541C22.8564 5.34668 20.8301 3.35937 18.8184 2.04102C16.7578 0.693359 14.6582 0.00488281 12.5684 0C12.5586 0 12.5488 0 12.5391 0C10.4443 0 8.3252 0.683594 6.25 2.03613C4.22363 3.34961 2.17285 5.3418 0.161133 7.94922C-0.0537109 8.23242 -0.0537109 8.62305 0.161133 8.90137C2.17285 11.5137 4.22363 13.5059 6.25 14.8193C8.33008 16.1719 10.4443 16.8555 12.5391 16.8555H12.5684C14.6582 16.8506 16.7627 16.1621 18.8184 14.8145C20.8301 13.4961 22.8516 11.5088 24.8389 8.90137C25.0537 8.62305 25.0537 8.23242 24.8389 7.9541ZM12.5635 15.293C12.5537 15.293 12.5439 15.293 12.5391 15.293C9.02832 15.293 5.40527 12.9834 1.77246 8.42773C5.40527 3.87207 9.02344 1.5625 12.5391 1.5625H12.5635C16.0645 1.57227 19.6533 3.88184 23.2275 8.42773C19.6533 12.9736 16.0693 15.2832 12.5635 15.293ZM12.5 3.54492C9.80957 3.54492 7.61719 5.73731 7.61719 8.42773C7.61719 11.1182 9.80957 13.3105 12.5 13.3105C15.1904 13.3105 17.3828 11.1182 17.3828 8.42773C17.3828 5.73731 15.1904 3.54492 12.5 3.54492ZM12.5 11.748C10.6689 11.748 9.17969 10.2588 9.17969 8.42773C9.17969 6.59668 10.6689 5.10742 12.5 5.10742C14.3311 5.10742 15.8203 6.59668 15.8203 8.42773C15.8203 10.2588 14.3311 11.748 12.5 11.748Z"
                fill="#666666"
              />
            </svg>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
      <section className="manageBooking py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="all"
                onSelect={(e) => setTab(e)}
              >
                <Nav
                  variant="pills"
                  className="underlineTab border-bottom justify-content-center mb-3"
                  style={{ maxWidth: "max-content" }}
                >
                  <Nav.Item style={{ minWidth: 150 }}>
                    <Nav.Link
                      eventKey="all"
                      className="bg-transparent position-relative fw-sbold text-center"
                    >
                      All
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item style={{ minWidth: 150 }}>
                    <Nav.Link
                      eventKey="complete"
                      className="bg-transparent position-relative fw-sbold text-center"
                    >
                      Completed
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item style={{ minWidth: 150 }}>
                    <Nav.Link
                      eventKey="new"
                      className="bg-transparent position-relative fw-sbold text-center"
                    >
                      New
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                {/* <Tab.Content>
                  <Tab.Pane eventKey="All"> */}
                {/* <AllTab
                  data={booking}
                  col={col}
                  loader={loader}
                  paginationHandler={paginationHandler}
                /> */}
                {/* </Tab.Pane> */}
                {/* <Tab.Pane eventKey="Completed">
                    <CompletedTab />
                  </Tab.Pane>
                  <Tab.Pane eventKey="New">
                    <NewTab />
                  </Tab.Pane>
                </Tab.Content> */}
                <div className="py-2">
                  <div className="table-responsive">
                    <Table data={booking} column={col} loader={loader} />
                    <div className="d-flex justify-content-end">
                      <CustomPagination
                        total={total}
                        current={body.page}
                        pageSize={body.limit}
                        pageChangeHandler={paginationHandler}
                      />
                    </div>
                  </div>
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageBooking;
